import api from "./api";

export interface KnowledgeCopyFolderItemsParams {
  itemIds: number[];
  targetFolderId: number | number[];
}

// 知识库文件复制
export const knowledgeCopyFolderItems = async (props: KnowledgeCopyFolderItemsParams) => {
  const res = await api.post<unknown>("/knowledge/copy_folder_items", {
    item_ids: props.itemIds,
    target_folder_id: props.targetFolderId,
  });
  return res;
};
